<template>
	<div class="list">
		<div class="list-tt">大运流年</div>
		<div class="list-info">
			<div>
				<div v-html="qiyun"></div>
				<div class="liu-box">
					<div class="liu-item">
						<div class="liu-name">大运</div>
						<ul class="dayun">
							<li v-for="item in daYun" @click="selectDayun(item,item.index)" :class="item.index==isDayYun?'on':''">
								<div>{{item.ganz||'童限'}}</div>
								<div class="tcolor">{{item.sYear}}</div>
								<div class="tcolor">{{item.eYear}}</div>
								<div class="tcolor">{{item.sAge}}-{{item.eAge}}岁</div>
								<div>{{item.shishen}}</div>
							</li>
						</ul>
					</div>
					<div class="liu-item">
						<div class="liu-name">小运</div>
						<ul class="dayun">
							<li v-for="item in xiaoYun" @click="selectXiaoyun(item,item.index)" :class="item.index==isXiaoYun?'on':''">
								<div>{{item.ganz}}</div>
								<div class="tcolor">{{item.year}}</div>
								<div class="tcolor">{{item.age}}岁</div>
								<div>{{item.shishen}}</div>
							</li>
						</ul>
					</div>
					<div class="liu-item">
						<div class="liu-name">流年</div>
						<ul class="dayun">
							<li v-for="item in liuNian" @click="selectXiaoyun(item,item.index)" :class="item.index==isXiaoYun?'on':''">
								<div>{{item.ganz}}</div>
								<div class="tcolor">{{item.year}}</div>
								<div class="tcolor">{{item.age}}岁</div>
								<div>{{item.shishen}}</div>
							</li>
						</ul>
					</div>
					<div class="liu-item">
						<div class="liu-name">流月</div>
						<ul class="dayun">
							<li v-for="item in liuYue">
								<div>{{item.ganz}}</div>
								<div class="tcolor">{{item.yue}}月</div>
								<div>{{item.shishen}}</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['liunian'],
		data() {
			return {
				infoHtml: '',
				sex: {
					1: 1,
					2: 0
				},
				times: ['子时（23-01点）', '丑时（01-03点）', '寅时（03-05点）', '卯时（05-07点）', '辰时（07-09点）', '巳时（09-11点）',
					'午时（11-13点）', '未时（13-15点）', '申时（15-17点）', '酉时（17-19点）', '戌时（19-21点）', '亥时（21-23点）'
				],
				qiyun: '',
				daYun: [],
				ganBase: {
					'甲': {
						wx: '木',
						yy: '阳'
					},
					'乙': {
						wx: '木',
						yy: '阴'
					},
					'丙': {
						wx: '火',
						yy: '阳'
					},
					'丁': {
						wx: '火',
						yy: '阴'
					},
					'戊': {
						wx: '土',
						yy: '阳'
					},
					'己': {
						wx: '土',
						yy: '阴'
					},
					'庚': {
						wx: '金',
						yy: '阳'
					},
					'辛': {
						wx: '金',
						yy: '阴'
					},
					'壬': {
						wx: '水',
						yy: '阳'
					},
					'癸': {
						wx: '水',
						yy: '阴'
					}
				},
				sheng: {
					木: '火',
					火: '土',
					土: '金',
					金: '水',
					水: '木'
				},
				ke: {
					木: '土',
					土: '水',
					水: '火',
					火: '金',
					金: '木'
				},
				yueGan: '',
				rzGan: '',
				xiaoYun: [],
				liuNian: [],
				liuYue: [],
				isDayYun:0,
				isXiaoYun:0,
				isLiuYue:0
			}
		},
		methods: {
			selectDayun(data, index) {
				this.getXiaoYun(data.xiaoyun);
				this.getLiuNian(data.liun);
				this.getLiuYue(this.liuNian[index].liuyue);
				this.isDayYun = index;
				this.isXiaoYun = 0;
				this.isLiuYue = 0;
			},
			selectXiaoyun(data, index) {
				this.getLiuYue(this.liuNian[index].liuyue);
				this.isXiaoYun = index;
				this.isLiuYue = 0;
			},
			getBazi() {
				var bazi = '';
				let type = this.liunian.type;
				let sex = this.liunian.sex;
				let year = this.liunian.year;
				let month = this.liunian.month;
				let day = this.liunian.day;
				let chen = [23, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22];
				let time = chen[this.liunian.time];
				let timeName = this.times[this.liunian.time];

				if (type == 2) { //农历
					let lunar = Lunar.fromYmdHms(year, month, day, time, 0, 0);
					bazi = lunar.getEightChar();
				} else {
					let solar = Solar.fromYmdHms(year, month, day, time, 0, 0);
					let lunar = solar.getLunar();
					bazi = lunar.getEightChar();
				}
				let gender = this.sex[sex];
				let yun = bazi.getYun(gender, 1);
				this.rzGan = bazi.getDayGan();
				this.yueGan = bazi.getMonthGan();
				this.qiyun = '起运：' + yun.getStartYear() + '年' + yun.getStartMonth() + '个月' + yun.getStartDay() + '天后起运(' + yun.getStartSolar()
					.toYmd() + ')';
				this.getDayun(yun.getDaYun());
			},
			getDayun(data) {
				let daLiuNian = [];
				for (let i in data) {
					let obj = {
						sYear: data[i].getStartYear(),
						eYear: data[i].getEndYear(),
						sAge: data[i].getStartAge(),
						eAge: data[i].getEndAge(),
						index: data[i].getIndex(),
						ganz: data[i].getGanZhi(),
						liun: data[i].getLiuNian(), //流年
						xiaoyun: data[i].getXiaoYun(), //小运
						shishen: this.getLiuNianGanShiShen(data[i].getGanZhi()[0])
					}
					daLiuNian.push(obj);
				}
				this.daYun = daLiuNian;
				this.getXiaoYun(daLiuNian[0].xiaoyun);
				this.getLiuNian(daLiuNian[0].liun);
			},
			getXiaoYun(data) {
				let xiaoyun = [];
				for (let x in data) {
					let obj = {
						year: data[x].getYear(),
						age: data[x].getAge(),
						index: data[x].getIndex(),
						ganz: data[x].getGanZhi(),
						shishen: this.getLiuNianGanShiShen(data[x].getGanZhi()[0])
					}
					xiaoyun.push(obj);
				}
				this.xiaoYun = xiaoyun;
			},
			getLiuNian(data) {
				let liunian = [];
				for (let x in data) {
					let obj = {
						year: data[x].getYear(),
						age: data[x].getAge(),
						index: data[x].getIndex(),
						ganz: data[x].getGanZhi(),
						liuyue: data[x].getLiuYue(), //流月
						shishen: this.getLiuNianGanShiShen(data[x].getGanZhi()[0])
					}
					liunian.push(obj);
				}
				this.liuNian = liunian;
				this.getLiuYue(liunian[0].liuyue)
			},
			getLiuYue(data) {
				let liuYue = data;
				let liuyue = [];
				for (let y in liuYue) {
					let objs = {
						yue: liuYue[y].getMonthInChinese(),
						index: liuYue[y].getIndex(),
						ganz: liuYue[y].getGanZhi(),
						shishen: this.getLiuNianGanShiShen(liuYue[y].getGanZhi()[0])
					}
					liuyue.push(objs);
				}
				this.liuYue = liuyue;
			},
			getLiuNianGanShiShen(liuGan) {
				let yueGan = this.yueGan;
				let riGan = this.rzGan;
				if (liuGan) {
					liuGan = liuGan;
				} else {
					liuGan = yueGan;
				}
				const me = this.ganBase[riGan];
				const tar = this.ganBase[liuGan];
				// 同五行
				if (me.wx === tar.wx) {
					return me.yy === tar.yy ? '比肩' : '劫财';
				}

				// 我生对方
				if (this.sheng[me.wx] === tar.wx) {
					return me.yy === tar.yy ? '食神' : '伤官';
				}

				// 我克对方
				if (this.ke[me.wx] === tar.wx) {
					return me.yy === tar.yy ? '偏财' : '正财';
				}

				// 对方克我
				if (this.ke[tar.wx] === me.wx) {
					return me.yy === tar.yy ? '七杀' : '正官';
				}

				// 对方生我
				if (this.sheng[tar.wx] === me.wx) {
					return me.yy === tar.yy ? '偏印' : '正印';
				}

				return '';
			}
		},
		watch: {
			liunian(newVal, oldVal) {
				this.getBazi()
			}
		},
	}
</script>

<style scoped="scoped">
	.tcolor{
		color: #b2b2b2;
	}
	.liu-name{
		text-align: center;
		line-height: 25px;
		width: 20px;
		color: #aaa;
		padding: 20px 10px;
	}
	.liu-item{
		display: flex;
	}
	.liu-box{
		font-size: 13px;
		padding-top: 20px;
	}
	.dayun {
		display: flex;
		padding: 0;
		margin: 0;
	}

	.dayun li {
		list-style: none;
		width: 66px;
		line-height: 22px;
		text-align: center;
		cursor: default;
		padding: 20px 0;
		height: 110px;
	}
	.dayun .on{
		background-color: #CC2535;
		color: #fff;
	}
	
	@media screen and (max-width: 640px) {
		.list-info{
			display: block;
		}
		.liu-box{
			display: flex;
			width: 100%;
		}
		.liu-item{
			display: block;
			width: 25%;
		}
		.dayun{
			display: block;
		}
		.liu-name{
			width: 100%;
			padding: 20px 0;
		}
		.dayun li{
			width: 100%;
		}
	}
</style>



// WEBPACK FOOTER //
// src/page/liunian.vue